<template>
  <div class="userinfo-wrap">
    <back-button />
    <div class="userinfo-main">
      <!-- <div class="userinfo-title">用户参赛信息</div> -->
      <div class="userinfo-avatar">
        <img :src="userInfo.avatar || defaultAvatar" alt="头像" />
      </div>
      <div class="userinfo-list">
        <van-cell title="真实姓名" :value="userInfo.name || '-'" />
        <van-cell title="所在地区" :value="getAreaText()" />
        <van-cell title="所属社区、村" :value="userInfo.village || '-'" />
        <van-cell title="注册单位名称" :value="userInfo.unit || '-'" />
        <van-cell title="人群类别" :value="getCrowdText(userInfo.crowd)" />
        <van-cell title="您的年龄" :value="getAgeText(userInfo.age)" />
        <van-cell title="手机号" :value="userInfo.mobile || '-'" />
      </div>
    </div>
  </div>
</template>
<script>
import BackButton from "@/components/BackButton.vue";
export default {
  components: {
    BackButton,
  },
  data() {
    return {
      userInfo: {},
      defaultAvatar: require("@/assets/default-avatar.png"),
      crowds: [
        { key: 1, text: "青少年" },
        { key: 2, text: "农民" },
        { key: 3, text: "老年人" },
        { key: 4, text: "产业工人" },
        { key: 5, text: "领导干部和公务员" },
      ],
      ages: [
        { key: 1, text: "18岁以下" },
        { key: 2, text: "18-29岁" },
        { key: 3, text: "30-39岁" },
        { key: 4, text: "40-49岁" },
        { key: 5, text: "50-59岁" },
        { key: 6, text: "60-69岁" },
        { key: 7, text: "69岁以上" },
      ],
    };
  },
  async created() {
    try {
      const res = await this.$axios.post("/User/getUserInfo");
      this.userInfo = res.data;
    } catch (error) {
      this.$notify({
        type: "danger",
        message: error.errorMsg || "获取用户信息失败",
        duration: 2000,
      });
    }
  },
  methods: {
    getAreaText() {
      const parts = [
        this.userInfo.city_name,
        this.userInfo.county_name,
        this.userInfo.town_name,
      ].filter(Boolean);
      return parts.join(" ");
    },
    getCrowdText(key) {
      const item = this.crowds.find(function (c) {
        return c.key == key;
      });
      return item ? item.text : "-";
    },
    getAgeText(key) {
      const item = this.ages.find(function (c) {
        return c.key == key;
      });
      return item ? item.text : "-";
    },
  },
};
</script>
<style lang="scss" scoped>
.userinfo-wrap {
  box-sizing: border-box;
  height: 100vh;
  padding: 25px 20px 20px;
  overflow: hidden;
  @include plain-bg;
  @include safe-area-bottom("20px");

  .userinfo-main {
    position: relative;
    box-sizing: border-box;
    height: 95%;
    padding: 40px 22px 0;
    overflow-y: auto;
    background-color: $white;
    border-radius: 8px;

    .userinfo-avatar {
      width: 80px;
      height: 80px;
      margin: 0 auto 20px;
      overflow: hidden;
      border: 3px solid #237dd2;
      border-radius: 50%;

      img {
        width: 100%;
        height: 100%;
        vertical-align: top;
      }
    }

    .userinfo-title {
      margin-bottom: 24px;
      font-size: 18px;
      font-weight: 600;
      color: #333;
      text-align: center;
    }

    .userinfo-list {
      ::v-deep .van-cell {
        padding: 14px 0;
        font-size: 15px;
        color: #333;

        .van-cell__title {
          flex: none;
          width: 110px;
          color: #666;
        }

        .van-cell__value {
          color: #333;
          text-align: right;
        }

        .van-cell__label {
          margin-top: 4px;
          font-size: 14px;
          color: #333;
          text-align: right;
        }
      }
    }
  }
}
</style>
